module.exports = __webpack_public_path__ + "img/gb-wls.acae1774.svg";